export default {
  status: { entwurf: 'Entwurf', auf_dem_geraet: 'Auf dem Gerät', erledigt: 'Erledigt', erledigt_anders: 'Erledigt – anders' },
  phase: { wiedereinstieg: 'Wiedereinstieg', grundlage: 'Grundlage', aufbau: 'Aufbau', spitze: 'Spitze', huegel: 'Hügel', tapering: 'Tapering', erholung: 'Erholung' },
  devicesOr: ' bzw. ',

  // Seite
  thisWeek: 'Diese Woche',
  nextWeek: 'Nächste Woche',
  lastWeek: 'Letzte Woche',
  isoWeek: 'KW {n}',
  legendLabel: 'Statuslegende',
  legendDraft: 'Entwurf – nur hier sichtbar',
  legendDevice: 'Auf dem Gerät – Garmin bzw. Wahoo',
  legendRoute: 'Weg: dashy-dash → intervals.icu → Garmin Connect / Wahoo → Gerät',
  whyLabel: 'Warum dieser Plan',
  whyTitle: 'Warum diese Woche so aussieht',
  aiMissing: 'KI-Text fehlt: {error}',
  byRulesAi: 'Vorschlag nach Regeln, Text von der KI',
  byRules: 'Vorschlag nach Regeln',
  noSuggestion: 'Für diese Woche gibt es noch keinen Vorschlag. Er entsteht aus Ampel, Form, Zielen und Serien – immer als Entwurf.',
  suggestWeek: 'Woche vorschlagen',
  unpushConfirm: '„{title}" vom Gerät zurücknehmen? Das Event bei intervals.icu wird gelöscht, der Entwurf bleibt hier.',
  loadError: 'Die Planung lässt sich gerade nicht laden.',
  retry: 'Nochmal versuchen',
  loading: 'Lädt …',
  kickerRace: 'Nächstes Rennen: {name} · {date}',
  pushNothing: 'Nichts aufs Gerät zu schicken',
  pushDrafts: { one: '1 Entwurf: Auswahl fürs Gerät …', other: '{count} Entwürfe: Auswahl fürs Gerät …' },
  prevWeek: 'Woche davor',
  nextWeekBtn: 'Woche danach',
  today: 'Heute',
  planning: 'Plant …',
  suggestAgain: 'Neu vorschlagen',
  drafts: { one: '{count} Entwurf', other: '{count} Entwürfe' },
  noDrafts: 'Keine Entwürfe offen',
  serieNote: ' · Laufserie: Serien-Meilen an Tagen ohne Lauf eingeplant',
  chat: 'Chat',
  toDevice: 'Aufs Gerät …',
  chatSheet: 'Planen per Chat',
  chatSheetBasis: 'Einzelworkout per Chat · Basis: letzte 42 Tage',
  chatTitle: 'Einzelworkout per Chat',

  // Woche
  week: 'Woche',
  restDay: 'Ruhetag',
  unpush: 'Zurücknehmen',

  // Chat
  chatNote: '{date} · Ziele mit Typ (z. B. Z2 HR), damit die Uhr nicht in Watt rechnet. Aufs Gerät geht es erst nach deinem Klick.',
  chatReason: 'Grund: {issue}',
  chatFailed: 'Das hat nicht geklappt: {error}',
  chatHint: 'Sag, was auf die Uhr soll – z. B. „Leg mir Dienstag 25 min easy mit 4 Steigerungen hin, Puls unter 138." Es landet als Entwurf im Plan.',
  chatOffBefore: 'KI ist aus. Einzelworkouts per Chat gehen erst, wenn in der Server-Umgebung ein KI-Anbieter gesetzt ist (',
  chatOffAfter: ').',
  thinking: 'Denkt nach …',
  message: 'Nachricht',
  messagePlaceholder: 'Nachricht …',
  askPlaceholder: 'Was soll auf die Uhr?',
  send: 'Senden',

  runWalkMeta: '{run} min laufen, {walk} min gehen',

  // Saison-Karte
  seasonTitle: 'Saison',
  seasonWeek: 'Diese Woche: {phase} · ~{km}',
  seasonWeekOther: 'Woche: {phase} · ~{km}',
  seasonNoWeek: 'Diese Woche steht nicht im Raster.',
  seasonNextRace: 'Nächstes Rennen: {name} · {date}',
  seasonWeeksToA: { one: 'Noch {count} Woche bis zum A-Rennen', other: 'Noch {count} Wochen bis zum A-Rennen' },
  seasonAThisWeek: 'A-Rennen in dieser Woche',
  seasonEmpty: 'Noch keine Rennen eingetragen. Aus der Rennliste entsteht der Saisonplan.',
  seasonLink: 'Zur Saison',
  planStarts: 'Dein Plan beginnt am {date}',
  planStartsText: 'Bis dahin ist nichts geplant. Den ganzen Plan findest du in der Saison.',

  // Freigabe
  releaseTitle: { one: '1 Workout aufs Gerät schicken?', other: '{count} Workouts aufs Gerät schicken?' },
  releaseTitleNone: 'Keine Einheit ausgewählt',
  releaseGoes: { one: 'Der Entwurf geht über intervals.icu auf {devices}.', other: '{count} Entwürfe gehen über intervals.icu auf {devices}.' },
  releaseGoesSome: { one: '1 von {total} Entwürfen geht über intervals.icu auf {devices}.', other: '{count} von {total} Entwürfen gehen über intervals.icu auf {devices}.' },
  releaseNoneSelected: 'Hake an, was aufs Gerät soll.',
  releaseOthersHint: ' Vorausgewählt sind nur Laufen und Rad; hake den Rest an, wenn du ihn auf dem Gerät haben möchtest.',
  releaseList: 'Einheiten fürs Gerät',
  releaseNone: 'Keine Entwürfe ab heute in dieser Woche.',
  releaseOnDevice: { one: ' Eine Einheit ist schon auf dem Gerät.', other: ' {count} Einheiten sind schon auf dem Gerät.' },
  intervalsOffBefore: 'intervals.icu ist nicht verbunden ({reason}). Ohne Key bleibt alles Entwurf – ',
  intervalsOffAfter: ' in der Server-Umgebung setzen.',
  noKey: 'kein Key',
  releaseInfo: 'Angehakte Einheiten landen über intervals.icu im Kalender und beim nächsten Sync auf dem Gerät. Zurücknehmen geht hier jederzeit.',
  cancel: 'Abbrechen',
  sending: 'Schickt …',
  sendToDevice: '{count} aufs Gerät schicken',
  close: 'Schließen',
  detail: {
    open: 'Details: {title}',
    move: 'Verschieben',
    moveTo: 'Auf {day} verschieben',
    moveHint: 'Tippe einen anderen Tag dieser Woche an. Vergangene Tage gehen nicht.',
    moveDevice: 'Sie ist schon auf dem Gerät – intervals.icu verschiebt sie mit.',
    delete: 'Löschen',
    deleteDraft: '„{title}" löschen?',
    deleteDevice: '„{title}" löschen? Sie wird auch vom Gerät genommen.',
    deleteYes: 'Ja, löschen',
    unpushYes: 'Ja, zurücknehmen',
    keep: 'Abbrechen',
    confirmLabel: 'Nachfrage',
    toActivity: 'Zur Aktivität',
    strip: 'Woche auf einen Blick',
  },
};
